import { EventTypes } from './../shared/EventTypes';
import { AppEventDispatcher } from './../utils/AppEventDispatcher';
import { Auth } from './Auth';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { ThemeService } from '../shared/theme-service/theme.service';
import { CustomerServiceService } from '../master/customer-service/customer-service.service';

@Injectable()
export class AutenticationGuard implements CanActivate {
	constructor(private router: Router, private themeService: ThemeService, private customerServiceService: CustomerServiceService) {

	}

	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

		const user = Auth.getInstance().getUser();
		const isAttendant = this.themeService.isAttendant();
		const attendantLogged = Auth.getInstance().getAttendantLogged();
		const inAttendance = this.customerServiceService.getAccountsClientList().length > 0;

		if (isAttendant && attendantLogged) {
			return true;
		} else if (state.url.includes('login') && user) {
			this.router.navigate(['']);
			return false;
		} else if (state.url.includes('login') && !user) {
			return true;
		} else if (user) {
			return true;
		} else {
			this.router.navigate(['login']);
			return false;
		}
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/autentication/autentication.guard.ts